export default "__VITE_ASSET__CObNraVU__"